import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Col, Input, InputGroup, InputGroupText, Row } from 'reactstrap';
import { SpinnerButton } from 'common/SpinnerButton';
import Logo from 'images/logo.png';
import './style.scss';
import { AuthContext } from "contexts/AuthContext";
import { adminLogin } from "utils/api";

export const AdminSignIn = () => {
    const { signIn, handleError, logout } = useContext(AuthContext);
    const navigate = useNavigate();
    const [submitting, setSubmitting] = useState(false);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const onSubmit = async () => {
        setSubmitting(true);

        try {
            const res = await adminLogin(email, password);

            const token = res?.dpb_token;

            if (token) {
                signIn(token);
                navigate('/admin/domains');
            }
        } catch (err) {
            handleError(err);
        }

        setSubmitting(false);
    };

    useEffect(() => {
        logout();
    }, []);

    return (
        <div className="auth-block">
            <div className="auth-block__inner">
                <div className="animated fadeIn">
                    <Row className="justify-content-center mt-5" style={{ marginBottom: '.5rem' }}>
                        <Col md={9}>
                            <div className="auth-block__image-container">
                                <a href="/frontend/src/routes">
                                    <img src={Logo} alt="Ozmosys" className="auth-block__image img-fluid"/>
                                </a>
                            </div>
                            <div className="text-center">
                                <h2>Admin GPT Researcher</h2>
                                <p className="mb-4 mt-3 text-muted">Please sign in to continue</p>
                            </div>

                            <InputGroup>
                                <InputGroupText className="input-addon">@</InputGroupText>
                                <Input
                                    placeholder="Email"
                                    name="email"
                                    value={email}
                                    type="email"
                                    autoComplete="email"
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                            </InputGroup>

                            <InputGroup>
                                <InputGroupText className="input-addon">
                                    <i className="fa fa-lock"/>
                                </InputGroupText>
                                <Input
                                    placeholder="Password"
                                    name="password"
                                    value={password}
                                    autoComplete="password"
                                    onChange={(e) => setPassword(e.target.value)}
                                    type="password"
                                />
                            </InputGroup>

                            <Row>
                                <Col xs="12" className="text-left">
                                    <SpinnerButton
                                        color="primary"
                                        block
                                        disabled={email.length < 1 || password.length < 1}
                                        onClick={onSubmit}
                                        submitting={submitting}
                                        title="Login"
                                    />
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </div>
            </div>
        </div>
    );
};
